import { render, staticRenderFns } from "./DispatchOrderDetailModal.vue?vue&type=template&id=095e33f6&scoped=true&"
import script from "./DispatchOrderDetailModal.vue?vue&type=script&lang=js&"
export * from "./DispatchOrderDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./DispatchOrderDetailModal.vue?vue&type=style&index=0&id=095e33f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095e33f6",
  null
  
)

export default component.exports